import { render, staticRenderFns } from "./ModalKas.vue?vue&type=template&id=7d6fe016&"
import script from "./ModalKas.vue?vue&type=script&lang=js&"
export * from "./ModalKas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports